import { PlessViewUtilsSub } from 'src/app/commons/kymw00/pless-view-utils-sub.service';
import { KYMW1319Component } from './kymw1319.component';
import { KYMW1319InputVO } from './vo/kymw1319-inputVO.model';
import { GetBundleCatalogInfoForFeatureResponce } from './api-services/get-bundle-catalog-info-for-feature.service';

/**
 * 特集付替設定画面の値を管理するクラス
 *
 * @export KYMW1319Model
 * @class KYMW1319Model
 */
export class KYMW1319Model {
  kymw1319Component: KYMW1319Component;

  /** 画面表示用 受注コード */
  public dispOrderCode = <string>'';
  /** 画面表示用 媒体 */
  public dispMedium = <string>'';

  /** 
   * 開始受注コード
   * 遷移元から引き継いだ値、または、GetBundleCatalogInfoForFeatureServiceで取得した値
   */
  public startOrderCode = <string>'';

  /** 設定済み特集一覧 */
  public selectedFeatureList = new Array();

  /** 設定候補特集 */
  public featureInfoList = new Array();
  /** 選択された設定候補特集 */
  public selectedFeatureCode = <string>'';

  /** 束ねフラグ　0：束ね企画対象外 */
  public readonly BUNDLE_CATALOG_NON_TARGET = '0';
  /** 束ねフラグ　1：束ね企画対象 */
  public readonly BUNDLE_CATALOG_TARGET = '1';
  /** 編集ロックフラグ 0：閲覧モード */
  public readonly READONLY_MODE = '0';
  /** 編集ロックフラグ 1：編集モード */
  public readonly EDIT_MODE = '1';
  /** 企画確定済みフラグ 1：企画確定済み */
  public readonly CATALOG_FIXED_FLAG = '1';

  /**
   * 遷移元からのデータを表示用にする
   * 
   * @param inputVO 
   */
  public formatDisplayValue(inputVO: KYMW1319InputVO, serverData: GetBundleCatalogInfoForFeatureResponce) {
    if (inputVO.bundleCatalogFlag === this.BUNDLE_CATALOG_TARGET) {
      // 束ね企画媒体の場合、「開始受注コード-終了受注コード:束ね企画名」
      this.startOrderCode = serverData.StartOrderCode ?? inputVO.startOrderCode;
      const orderCodeEnd = serverData.EndOrderCode ?? inputVO.endOrderCode;
      const bundleCatalogName = serverData.BundleCatalogRoundName ?? inputVO.bundleCatalogRoundName;
      this.dispOrderCode = this.startOrderCode + '-' + orderCodeEnd + ':' + bundleCatalogName;
    } else {
      // 束ね企画対象外媒体の場合、受注コード
      this.dispOrderCode = inputVO.orderCode;
    }

    // 媒体区分の整形　「媒体区分 + ":" + 媒体名」
    this.dispMedium = inputVO.mediumType + ':' + inputVO.mediumName;
  }

  /**
   * 設定済み特集一覧のデータを表示用にする
   * 
   * @param list 
   */
  public formatListValue(list: Array<any>) {
    this.selectedFeatureList = list.map(item => ({
      ...item,
      DispFeature: (!PlessViewUtilsSub.isEmpty(item.FeatureCode) && !PlessViewUtilsSub.isEmpty(item.FeatureName))
        ? item.FeatureCode + ':' + item.FeatureName : '', // 「特集コード:特集名」
    }))
  }
}
